/** 首次已登记提示标记 */
export const CStorageKeyFirstRegisted = 'key_first_registed';
/** 首次审核通过提示标记 */
export const CStorageKeyFirstApproved = 'key_first_approved';
/** 政府消费券首次派券成功提示标记 */
export const CStorageKeyGovFirstSendSucc = 'key_first_gov_2022_send_succ';
export const CStorageKeyGovFirstSendTransfer = 'key_first_gov_send_transfer';
export const CStorageKeyGovFirstSendUndo = 'key_first_gov_send_undo';
/** 加码金首次生效提示标记 */
export const CStoreKeyPromFirstSendSucc = 'key_first_prom_send_succ';
/** 点击跳到政府页面打标 */
export const CStoreKeyClickGotoGovBtn = 'key_regcomp_togov_click';
export const CStoreKeyClickGotoGovBtn1 = 'key_regcomp_togov_click1';
/** referrer标记 */
export const CStoreKeyFromHomepage = 'key_from_homepage';
export const EggActFirstkey = 'EggActFirstkeyNew0724';

/** 调用方场景 */
export enum EScene {
  empty = '', // 未知
  homepage = 'homepage',  // homepage调用
  act = 'act',  // 活动页调用
}
